<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <h1 style="float: left;">{{ $root.title}}</h1>
      <div action="#" method="get" class="sidebar-form searchBox" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
      <div class="box-tools" style="float: right; padding: 0px 10px;">
        <ul class="pagination pagination-sm inline" style="cursor: pointer;">
          <li :class="[options.activeFilter==='Online' ? 'active' : '']"><a @click="options.activeFilter='Online'" style="width: 80px!important; text-align: center;">Online</a></li>
          <li :class="[options.activeFilter==='Offline' ? 'active' : '']"><a @click="options.activeFilter='Offline'" style="width: 80px!important; text-align: center;">Offline</a></li>
          <li :class="[options.activeFilter==='Out of Paper' ? 'active' : '']"><a @click="options.activeFilter='Out of Paper'" style="width: 80px!important; text-align: center;">Out of Paper</a></li>
          <li :class="[options.activeFilter==='Low Toner' ? 'active' : '']"><a @click="options.activeFilter='Low Toner'" style="width: 80px!important; text-align: center;">Low Toner</a></li>
          <li :class="[options.activeFilter==='Errors' ? 'active' : '']"><a @click="options.activeFilter='Errors'" style="width: 80px!important; text-align: center;">Errors</a></li>
        </ul>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive0">
        <div class="col-sm-12" style="padding-left: 0px; background-color: #ddd; padding-bottom: 10px; border-radius: 5px;">
          <div class="col-sm-2" v-show="$root.isAdmin">
            <span>Select Dealer:</span>
            <select class="form-control" v-model="filters.dealerKey" style="padding-left: 0px;">
              <!--<option value="All">All</option>-->
              <option v-for="(item,index) in sortedDelaers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div v-if="$root.isAdmin || $root.isDealer" class="col-sm-2">
            <span>Select Customer:</span>
            <select class="form-control" v-model="filters.customerKey" style="padding-left: 0px;">
              <option value="All">All</option>
              <!--<option v-for="(item,index) in $root.customers" :value="item.value">{{ item.title }}</option>-->
              <option v-for="(item,index) in customers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2">
            <span>Select Site:</span>
            <select class="form-control" v-model="filters.siteKey" style="padding-left: 0px;">
              <option value="All">All</option>
              <option v-for="(item,index) in sites" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-success" value="Refresh" style="margin-top: 20px;" @click="loadPrintersHistory" />
          </div>
        </div>
        <VueTable :isLoading="isLoading" :columns="columns" :rows="filteredItems" @rowClick="rowClick" :info="infoIcons" :options="options"></VueTable>
      </div>
      <!-- /.table-responsive -->
    </div>
    <PrinterInfo></PrinterInfo>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import printerItem from '../components/PrinterItem'
  import PrinterInfo from '../components/PrinterInfo'
  import VAButton from '../components/VAButton'
  import VAAlert from '../components/VAAlert.vue'
  import { GetPrintersHistory } from '../plugins/printersHistory.js'

  // import { db, dbStore, func } from '../firebase'
  import { db } from '../firebase'
  export default {
    name: 'printersStatus',
    components: { VueTable, printerItem, 'va-alert': VAAlert, PrinterInfo, 'va-button': VAButton },
    data () {
      return {
        isLoading: false,
        item: printerItem,
        printersHistory: [],
        paginator: null,
        activeFilter: 'Online',
        customers: [],
        sites: [],
        filters: {
          dealerKey: '',
          customerKey: '',
          siteKey: '',
          fromDate: '', // 2019-04-10
          toDate: '' // 2019-04-10
        },
        infoIcons: [
          { icon: 'fa fa-circle text-green', label: 'Online' },
          { icon: 'fa fa-circle text-red', label: 'Offline' },
          { icon: 'fa fa-circle text-orange', label: 'Other' }
        ],
        options: { showDefault: false, activeFilter: 'Toners' },
        columns: [
          { fieldName: 'Status', label: '', isSortable: false, isHidden: false, isStatus: true },
          // { fieldName: 'Logged', label: 'Date', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'Logged', sortFieldName: 'LoggedInt', label: 'Date', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'MacAddress', label: 'MAC Address', isSortable: true, isHidden: false },
          { fieldName: 'PrinterSerial', label: 'Serial', isSortable: true, isHidden: false, isLink: true, param: 'MacAddress' },
          { fieldName: 'IsUSB', label: '', isSortable: false, isHidden: false, isStatus: true },
          { fieldName: 'ModelName', label: 'Model', isSortable: true, isHidden: false, length: 18 },
          { fieldName: 'PageCount', label: 'Pages', isSortable: true, isHidden: false },
          { fieldName: 'IPAddress', label: 'IP Address', isSortable: true, isHidden: false },
          { fieldName: 'HostName', label: 'Host', isSortable: true, isHidden: false },
          // { fieldName: 'Location', label: 'Location', isSortable: true, isHidden: false, filterKey: 'Info', length: 10 },
          { fieldName: 'Dealer', label: 'Dealer', isSortable: true, isHidden: false, length: 10 },
          { fieldName: 'Customer', label: 'Customer', isSortable: true, isHidden: false, length: 10 },
          { fieldName: 'Site', label: 'Site', isSortable: true, isHidden: false, length: 10 },
          { fieldName: 'Status', label: 'Status', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'ErrorString', label: 'Error', isSortable: true, isHidden: false, length: 20 },
          { fieldName: 'A4Black', label: 'A4Black', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'A4Color', label: 'A4Color', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'A3Black', label: 'A3Black', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'A3Color', label: 'A3Color', isSortable: true, isHidden: false, width: '80px' },
          { fieldName: 'BlackTonerLeft', label: 'Black', isSortable: true, isHidden: false, isProgress: true },
          { fieldName: 'CyanTonerLeft', label: 'Cyan', isSortable: true, isHidden: false, isProgress: true },
          { fieldName: 'MagentaTonerLeft', label: 'Magenta', isSortable: true, isHidden: false, isProgress: true },
          { fieldName: 'YellowTonerLeft', label: 'Yellow', isSortable: true, isHidden: false, isProgress: true },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              // { name: 'InfoPrinter', label: 'Printer Info', iconClass: 'fa fa-info-circle', color: '#3c8dbc' }
              { name: 'InfoPrinter', label: 'Printer Info', iconClass: 'fa fa-info-circle', color: '#3c8dbc', isLink: true, param: 'MacAddress' }
            ]
          }
        ]
      }
    },
    created () {
      this.$root.title = 'Printers Status'
      if (this.$root.isAdmin) {
        if (this.$root.dealers && this.$root.dealers.length > 0) {
          this.filters.dealerKey = this.$root.dealers[0].value
        } else {
          this.filters.dealerKey = this.$root.user['.key']
        }
        this.filters.customerKey = this.$root.filter.customerKey
        this.filters.siteKey = 'All'
      } else if (this.$root.isDealer) {
        this.filters.dealerKey = this.$root.user['.key']
      } else {
        this.filters.dealerKey = this.$root.filter.dealerKey
        this.filters.customerKey = this.$root.filter.customerKey
      }
      this.filters.fromDate = this.$moment().add(-7, 'days').format('YYYY-MM-DD')
      this.filters.fromDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD')
      this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      // if (this.$root.userHistory && this.$root.userHistory.selectedTab) {
      //   this.activeFilter = this.$root.userHistory.selectedTab
      // }
      if (this.$root.userHistory) {
        if (this.$root.userHistory.selectedTab) {
          this.activeFilter = this.$root.userHistory.selectedTab
        }
        if (this.$root.userHistory.fromDate) {
          this.filters.fromDate = this.$root.userHistory.fromDate
        }
        if (this.$root.userHistory.toDate) {
          this.filters.toDate = this.$root.userHistory.toDate
        }
        this.$root.userHistory.selectedDealer = this.filters.dealerKey
        this.$root.userHistory.selectedCustomer = this.$route.params.customerKey
        this.$root.userHistory.selectedSite = this.$route.params.siteKey
        this.filters.customerKey = this.$route.params.customerKey
        this.filters.siteKey = this.$route.params.siteKey
        this.$root.setUserHistory()
      } else {
        this.filters.fromDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD')
        this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      }
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      fromDateInt () {
        // return Number(this.$moment(this.filters.fromDate).format('YYYYMMDDHHmm'))
        return Number(this.$moment(this.filters.fromDate).format('YYYYMMDD') + '0000')
      },
      toDateInt () {
        // return Number(this.$moment(this.filters.toDate).format('YYYYMMDDHHmm'))
        return Number(this.$moment(this.filters.toDate).format('YYYYMMDD') + '2359')
      },
      hasDateRange () {
        return (this.filters.fromDate && this.filters.toDate)
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.printersHistory.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.printersHistory
        }
        return result
      },
      sortedDelaers () {
        let vm = this
        return vm.$root.dealers.sort(vm.compareItems)
      }
    },
    watch: {
      activeFilter (val) {
        if (val !== 'All') {
          this.$root.userHistory.selectedTab = val
          this.$root.setUserHistory()
        }
      },
      'filters.dealerKey' (val) {
        console.log('filters.dealerKey = ' + val)
        this.printersHistory = []
        if (this.$route.params.customerKey) {
          this.filters.customerKey = this.$route.params.customerKey
          if (this.$route.params.siteKey) {
            this.filters.siteKey = this.$route.params.siteKey
          } else {
            this.filters.siteKey = 'All'
          }
        } else {
          this.filters.customerKey = 'All'
          this.filters.siteKey = 'All'
        }
        this.loadCustomers(val)
        /*
        if (this.$route.params.customerKey && this.$route.params.customerKey !== 'All') {
          if (this.$route.params.siteKey && this.$route.params.siteKey !== 'All') {
            if (this.hasDateRange) {
              this.loadPrintersHistory()
            }
          }
        }
        */
      },
      'filters.customerKey' (val) {
        this.printersHistory = []
        console.log('filters.customerKey = ' + val)
        this.$route.params.customerKey = val
        if (this.$route.params.siteKey) {
          // this.filters.siteKey = this.$route.params.siteKey
          this.filters.siteKey = 'All'
        } else {
          this.filters.siteKey = 'All'
        }
        this.loadSites(val)
        if (this.$route.params.customerKey && this.$route.params.customerKey !== 'All') {
          if (this.$route.params.siteKey && this.$route.params.siteKey !== 'All') {
            if (this.hasDateRange) {
              // this.loadPrintersHistory()
            }
          }
        }
      },
      'filters.siteKey' (val) {
        this.printersHistory = []
      }
    },
    methods: {
      compareItems (a, b) {
        try {
          const nameA = a.title.toUpperCase()
          const nameB = b.title.toUpperCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        } catch (e) {
          return 0
        }
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'RefreshPrinter': this.refreshPrinter(item); break
          case 'InfoPrinter': this.info(item); break
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      getItemprops (itemIndex) {
        // const itemProps = getItemProp(itemIndex)
        const itemProps = {
          Index: itemIndex,
          IPAddress: itemIndex + '111.111.111.111',
          ModelName: itemIndex + 'CCC BBBB DDDD FFFFFF 55'
        }
        return {
          // <item/> will render with itemProps.
          // https://vuejs.org/v2/guide/render-function.html#createElement-Arguments
          props: itemProps
        }
      },
      loadCustomers (dealerKey) {
        console.log('loadCustomers()...')
        console.log('dealerKey = ' + dealerKey)
        const vm = this
        vm.sites = []
        vm.customers = []
        vm.customers = vm.$root.customers.filter(function (customer) {
          return customer.dealerKey === vm.filters.dealerKey
        })
        vm.customers = vm.customers.sort(vm.compareItems)
      },
      loadSites (customerKey) {
        console.log('loadSites()...')
        console.log('customerKey = ' + customerKey)
        const vm = this
        // const sitesPath = 'Dealers/' + vm.$root.user['.key'] + '/Customers/' + customerKey + '/Sites'
        // const sitesRef = db.ref(sitesPath)
        vm.sites = []
        /*
        vm.sites = vm.$root.sites.filter(function (site) {
          return site.dealerKey === vm.filters.dealerKey && vm.filters.customerKey === customerKey
        })
        */
        vm.$root.sites.forEach(function (site) {
          if (site) {
            if (site.dealerKey === vm.filters.dealerKey) {
              if (vm.filters.customerKey === site.customerKey) {
                vm.sites.push(site)
              }
            }
          }
        })
        vm.sites = vm.sites.sort(vm.compareItems)
        // console.log(vm.sites)
        /*
        sitesRef.once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            // console.log(data)
            const keys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let site = data[key]
              site['.key'] = key
              site['customerKey'] = customerKey
              vm.sites.push(site)
            }
          }
        })
        */
      },
      parseTonerLeft (colorLeft) {
        let colorLeftInt = 0
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            colorLeftInt = 0
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          colorLeftInt = parseInt(colorLeft, 10)
        } else {
          colorLeftInt = -1
        }
        // if (colorLeftInt > 100) { colorLeftInt = 100 }
        // if (colorLeftInt < 0) { colorLeftInt = 0 }
        if (isNaN(colorLeftInt)) {
          colorLeftInt = 0
        }
        return colorLeftInt
      },
      loadPrintersHistory_OLD () {
        console.log('loadPrintersHistory()...')
        const vm = this
        vm.isLoading = true

        vm.$root.userHistory.selectedCustomer = vm.$route.params.customerKey
        vm.$root.userHistory.selectedSite = vm.$route.params.siteKey
        vm.$root.userHistory.fromDate = vm.filters.fromDate
        vm.$root.userHistory.toDate = vm.filters.toDate
        vm.$root.setUserHistory()

        let childKey = 'DateDealerKey'
        let startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
        let endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        if (vm.filters.customerKey === 'All') {
          childKey = 'DateDealerKey'
          startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
          endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        } else {
          if (vm.filters.siteKey === 'All') {
            childKey = 'DateDealerCustomerKey'
            startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.fromDateInt
            endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.toDateInt
          } else {
            childKey = 'DateDealerCustomerSiteKey'
            startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.fromDateInt
            endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.toDateInt
          }
        }
        console.log(childKey)
        console.log(startAtValue)
        console.log(endAtValue)

        // 9C-93-4E-48-F0-2E
        // db.ref('History').orderByChild(childKey).startAt(startAtValue).endAt(endAtValue).limitToFirst(50).on('value', (snapPrintersHistory) => {
        // db.ref('History').orderByChild(childKey).startAt(startAtValue).endAt(endAtValue).on('value', (snapPrintersHistory) => {
        db.ref('History').orderByChild(childKey).startAt(startAtValue).endAt(endAtValue).limitToLast(100).once('value', (snapPrintersHistory) => {
          console.log('History Data >>>')
          vm.printersHistory = []
          const data = snapPrintersHistory.val()
          if (data) {
            console.log(data)
            const pritnerKeys = Object.keys(data)
            for (let i = 0; i < pritnerKeys.length; i++) {
              let pKey = pritnerKeys[i]
              let printer = data[pKey]
              printer['.key'] = pKey
              let dealer = vm.$root.dealers.find(c => c.value === printer.DealerKey)
              if (dealer) {
                printer['Dealer'] = dealer.title
              }
              let cust = vm.$root.customers.find(c => c.value === printer.CustomerKey)
              if (cust) {
                printer['Customer'] = cust.title
              }
              let site = vm.$root.sites.find(c => c.value === printer.SiteKey)
              if (site) {
                printer['Site'] = site.title
              }
              printer.PageCount = parseInt(printer.PageCount, 10)
              printer.A4Black = parseInt(printer.A4Black, 10)
              printer.A4Color = parseInt(printer.A4Color, 10)
              printer.A3Black = parseInt(printer.A3Black, 10)
              printer.A3Color = parseInt(printer.A3Color, 10)
              printer.BlackTonerLeft = vm.parseTonerLeft(printer.BlackTonerLeft, 10)
              printer.CyanTonerLeft = vm.parseTonerLeft(printer.CyanTonerLeft, 10)
              printer.MagentaTonerLeft = vm.parseTonerLeft(printer.MagentaTonerLeft, 10)
              printer.YellowTonerLeft = vm.parseTonerLeft(printer.YellowTonerLeft, 10)
              vm.printersHistory.push(printer)
            }
            vm.printersHistory = vm.printersHistory.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
            vm.isLoading = false
          } else {
            console.log('printersHistory NO DATA !!')
            vm.isLoading = false
          }
          vm.isLoading = false
        })

        /*
        var options = {
          pageSize: 15,
          finite: true,
          auth: 'MyAuthTokenForSecurityPurposes',
          retainLastPage: false
        }

        vm.paginator = new FirebasePaginator(db.ref('History'))

        var handler = function () {
          collection = vm.paginator.collection
        }

        // vm.paginator.once('value').then(handler)
        vm.paginator.on('value').then(handler)
        */
      },
      loadPrintersHistory () {
        console.log('loadPrintersHistory()...')
        const vm = this
        // vm.testFunc()
        vm.isLoading = true
        vm.$root.userHistory.selectedCustomer = vm.$route.params.customerKey
        vm.$root.userHistory.selectedSite = vm.$route.params.siteKey
        vm.$root.userHistory.fromDate = vm.filters.fromDate
        vm.$root.userHistory.toDate = vm.filters.toDate
        vm.$root.setUserHistory()

        let childKey = 'DateDealerKey'
        let startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
        let endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        if (vm.filters.customerKey === 'All') {
          childKey = 'DateDealerKey'
          startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
          endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        } else {
          if (vm.filters.siteKey === 'All') {
            childKey = 'DateDealerCustomerKey'
            startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.fromDateInt
            endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.toDateInt
          } else {
            childKey = 'DateDealerCustomerSiteKey'
            startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.fromDateInt
            endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.toDateInt
          }
        }
        console.log(childKey)
        console.log(startAtValue)
        console.log(endAtValue)
        let fromDate = {
          Year: Number(vm.$moment(vm.filters.fromDate).format('YYYY')),
          Month: Number(vm.$moment(vm.filters.fromDate).format('MM')),
          Day: Number(vm.$moment(vm.filters.fromDate).format('DD')),
          Path: ''
        }
        let toDate = {
          Year: Number(vm.$moment(vm.filters.toDate).format('YYYY')),
          Month: Number(vm.$moment(vm.filters.toDate).format('MM')),
          Day: Number(vm.$moment(vm.filters.toDate).format('DD')),
          Path: ''
        }
        fromDate.Path = vm.$moment(vm.filters.fromDate).format('YYYY') + '/' + vm.$moment(vm.filters.fromDate).format('MM') + '/'
        toDate.Path = vm.$moment(vm.filters.toDate).format('YYYY') + '/' + vm.$moment(vm.filters.toDate).format('MM') + '/'
        let diffDate = {
          Year: toDate.Year - fromDate.Year,
          Month: toDate.Month - fromDate.Month,
          Day: toDate.Day - fromDate.Day
        }
        var startDateString = vm.filters.fromDate
        var endDateString = vm.filters.toDate
        var startDate = vm.$moment(startDateString, 'YYYY-MM-DD')
        var endDate = vm.$moment(endDateString, 'YYYY-MM-DD').endOf('month')
        var datesPathList = []
        while (startDate.isBefore(endDate)) {
          datesPathList.push(startDate.format('YYYY/MM/'))
          startDate = startDate.add(1, 'month')
        }
        console.log(diffDate)
        // console.log('Call GetSubCollections() ... ')
        // let docPath = '/PrintersHistory/Dealers/' + vm.filters.dealerKey + '/Customers'
        // const getSubCollections = func.httpsCallable('GetSubCollections')
        vm.printersHistory = []
        let fromDateStr = vm.fromDateInt + ''
        let toDateStr = vm.toDateInt + ''
        let selectedCustomersKeys = []
        if (vm.filters.customerKey === 'All') {
          vm.customers.forEach(function (cust) {
            selectedCustomersKeys.push(cust.value)
          })
        } else {
          selectedCustomersKeys.push(vm.filters.customerKey)
        }
        let historyFilters = {
          fromDate: fromDateStr,
          toDate: toDateStr,
          dealer: vm.filters.dealerKey,
          customers: selectedCustomersKeys,
          datePaths: datesPathList
        }
        GetPrintersHistory(vm, historyFilters).then(function (result) {
          console.log(result)
          if (result.Success) {
            vm.printersHistory = result.Data
          }
          vm.isLoading = false
        }).catch(function (error) {
          console.log(error)
          vm.isLoading = false
        })
      },
      toHistoryArray () {
        console.log('toHistoryArray...')
        const vm = this
        vm.printersHistory = []
        if (vm.pHistory) {
          let keys = Object.keys(vm.pHistory)
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if (key !== '.key') {
              // console.log(key)
              const printer = vm.pHistory[key]
              const datesKeys = Object.keys(printer)
              for (let j = 0; j < datesKeys.length; j++) {
                const dateKey = datesKeys[j]
                const logPrinter = printer[dateKey]
                // logPrinter.LogDate = dateKey
                // logPrinter.Mac = key
                vm.printersHistory.push(logPrinter)
              }
            }
          }
          /*
          for (var i = 0; i < vm.printersHistory; i++) {
            const key = vm.printersHistory[i]['.key']
            console.log(key)
          }
          */
        }
      },
      info (item) {
        const vm = this
        vm.$bus.$emit('printerInfoModal-open', item)
      },
      getPercent (colorLeft) {
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            return '0%'
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          return colorLeft + '%'
        } else {
          return '0%'
        }
      }
    }
  }
</script>
<style>
  .searchBox {
    border-radius: 3px;
    overflow: hidden;
    text-overflow: clip;
  }
    .searchBox input[type="text"] {
      color: #666;
      border-top-left-radius: 2px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 2px;
    }
    .searchBox .btn {
      color: #999;
      border: 1px solid transparent;
      box-shadow: none;
      border-top-left-radius: 0;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      border-bottom-left-radius: 0;
    }
</style>




// WEBPACK FOOTER //
// PrintersStatus.vue?7223f7ff